import { t } from '#i18n';

const humanizeDuration = require('humanize-duration');

export const ONE_SECOND = 1000;

export const ONE_MINUTE = 60 * ONE_SECOND;

export const ONE_HOUR = 60 * ONE_MINUTE;

export const ONE_DAY = 24 * ONE_HOUR;

export const ONE_WEEK = 7 * ONE_DAY;

export const ONE_MONTH = 30 * ONE_DAY;

const parser = humanizeDuration.humanizer({
  language: 'custom',
  languages: {
    custom: {
      y: () => t('duration.short.year'),
      mo: () => t('duration.short.month'),
      w: () => t('duration.short.week'),
      d: () => t('duration.short.day'),
      h: () => t('duration.short.hour'),
      m: () => t('duration.short.minute'),
      s: () => t('duration.short.second'),
      ms: () => t('duration.short.millisecond'),
    },
  },

});

export const durationToString = (durationInMs, options = {}) => parser(durationInMs, {
  delimiter: ' ',
  spacer: '',
  units: ['d', 'h', 'm'],
  round: true,
  ...options,
});

export const msToHours = (ms) => ms / ONE_HOUR;

export const hoursToMs = (hours) => Math.round(hours * ONE_HOUR);

export const secondsToMs = (seconds) => seconds * 1000;

export const calculateDayDifference = (startDate, endDate) => {
  const diffInMs = Math.abs(endDate - startDate);
  return Math.floor(diffInMs / ONE_DAY);
};
